import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getGuidedSearchData } from "../../../state/modules/search";
import { hasRenderableGuidedSearch } from "../../../features/browse-search/components/GuidedSearch/normaliseVisualRefinements";

export const GUIDED_SEARCH_FEATURE = "plp-guided-search";

const useGuidedSearchActivationFeatures = (matchedFeatures) => {
  const guidedSearchData = useSelector(getGuidedSearchData);
  const canRenderGuidedSearch = hasRenderableGuidedSearch(guidedSearchData);

  return useMemo(
    () =>
      canRenderGuidedSearch
        ? matchedFeatures
        : matchedFeatures.filter(([key]) => key !== GUIDED_SEARCH_FEATURE),
    [matchedFeatures, canRenderGuidedSearch],
  );
};

export default useGuidedSearchActivationFeatures;
